import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    bloodGroups: [],
    bloodGroupsCount: 0,
    bloodGroup: {},
    bloodGroupSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getBloodGroups(state) {
      return state.bloodGroups
    },
    getBloodGroupsCount(state) {
      return state.bloodGroupsCount
    },
    getBloodGroup(state) {
      return state.bloodGroup
    },
    getBloodGroupSaveStatus(state) {
      return state.bloodGroupSave
    },
  },
  mutations: {
    BLOOD_GROUPS_LIST(state, data) {
      state.bloodGroups = data
    },
    BLOOD_GROUP_VIEW(state, data) {
      state.bloodGroup = data
    },
    BLOOD_GROUPS_COUNT(state, data) {
      state.bloodGroupsCount = data
    },
    BLOOD_GROUP_SAVE(state, data) {
      state.bloodGroupSave = data
    },
  },
  actions: {
    bloodGroupsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/blood_group', data)
        .then(response => {
          commit('BLOOD_GROUPS_LIST', response.data.data)
          commit('BLOOD_GROUPS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    bloodGroupView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'blood_group.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/blood_group', data)
        .then(response => {
          commit('BLOOD_GROUP_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    bloodGroupSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/blood_group/saveData', data)
        .then(response => {
          commit('BLOOD_GROUP_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
